<template>
  <div v-if="org && org.privacy_policy">
    <div class="body">
      <p
        style="white-space:pre-wrap; word-wrap:break-word;"
        class="infotxt"
        v-html="linkedText"
      ></p>
    </div>
  </div>
</template>

<script>
import { globalData } from "@/global";
export default {
  computed: {
    org() {
      return globalData.org;
    },
    linkedText() {
      // 正規表現でURLを検出し、<a>タグで置換
      if (globalData.org && globalData.org.privacy_policy) {
        return globalData.org.privacy_policy.replace(
          /(https?:\/\/[^\s<>()]+)/g,
          '<a href="$1" target="_blank" rel="noopener noreferrer" class="infolink">$1</a>'
        );
      } else {
        return "";
      }
    }
  }
};
</script>

<style scoped>
.body {
  font-size: 14px;
  margin: 10px 0px;
  padding: 20px 15px;
  border-top: 1px solid #cecece;
  border-bottom: 1px solid #cecece;
}

.infotxt >>> .infolink {
  appearance: none;
  color: #78ba00;
  text-decoration: underline;
  border: none;
  padding: 0;
  margin: 0;
  font-style: normal;
  font-size: inherit;
  cursor: pointer;
  background: none;
}

.infotxt >>> .infolink:hover {
  text-decoration: none;
}
</style>
